/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { HiEye, HiEyeOff } from 'react-icons/hi'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'
import Form        from '@/Form/toolkit/Form'
import Loader      from '@Pure/Loader'

function getToken ()
{
	if (document.location.href.includes('?token='))
	{
		let token = document.location.href.split('?token=');

		token = token[1] || 'no-token';

		token = token.split('&')[0];

		return token || 'no-token';
	}

	return document.location.pathname
	.slice(document.location.pathname.lastIndexOf('/')+1) || 'no-token';
}

export default class NewPasswordForm extends Component
{
	state =
	{
		form_data: { 'token[string]': getToken() },

		pwd_conf_type: 'password',
		pwd_type: 'password',

		status_message: { }
	};

	handleChange = handleChange.bind(this);

	togglePwdVisibility = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			pwd_type: state.pwd_type === 'password'
			? 'text'
			: 'password'
		});
	}

	togglePwdConfVisibility = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			pwd_conf_type: state.pwd_conf_type === 'password'
			? 'text'
			: 'password'
		});
	}

	handleValidation = (response) =>
	{
		const component = this, props = this.props, state = this.state;

		let form_data = this.state.form_data, status_messages;

		status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		Object.keys(form_data).forEach(function (field, index)
		{
			if (Boolean(form_data[field]) === form_data[field])
			{
				form_data[field] = false;
			}
			else
			{
				form_data[field] = '';
			}
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			info: response.info,
			loading: false,
			form_data: form_data,
			status_messages: status_messages
		});
	}

	handleFailure = (response) =>
	{
		const component = this, props = this.props;

		let status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			status_messages: status_messages,
			loading: false
		});
	}

	handleSubmit = () =>
	{
		const component = this, props = this.props;

		component.setState({ loading: true });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let form_data = component.state.form_data, loader, status_message;

		let form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

		form_status.forEach(function (status, index)
		{
			if (typeof component.state[status.label] === 'undefined') return;

			status_message =
			(
				<div className={ 'c-form-message ' +
					'c-form-message' + status.suffix }>
					<div className="c-form-message__content">
						{ component.state[status.label] }
					</div>
				</div>
			);
		});

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			);
		}

		let submit =
		(
			<div className="c-btn-container c-btn-container--form u-margin-bottom-15">
				<button type="submit" className="c-btn c-btn--primary c-btn--extra"
					onClick={ function (e) { e.target.blur(); } }>
					Valider ce mot de passe
					{ loader }
				</button>
			</div>
		);

		const PwdIcon = state.pwd_type === 'password'
		? HiEye
		: HiEyeOff;

		const PwdConfIcon = state.pwd_conf_type === 'password'
		? HiEye
		: HiEyeOff;

		let output =
		(
			<Form className={ props.className + ' form-registration' }
				action="/nouveau-mot-de-passe"
				data={ form_data }
				onError={ component.handleFailure }
				onValidate={ component.handleValidation }
				onSubmit={ component.handleSubmit }
				history={ props.history }
				hide_button={ true }>

				<div className="home-tabs">
					<div className="c-tab c-tab--active" style={ { width: '100%' } }>
						<h2 className="c-tab__label">Mot de passe oublié</h2>
					</div>
				</div>

				<div className="form-registration__content">

					<div className="o-grid-2">

						<div className="o-grid__item">
							<div className="form__pwd-toggle-field">
								<FormElement type={ state.pwd_type }
									name="user[password]"
									label="Mot de passe"
									id_prefix="new-password-form-"
									onChange={ component.handleChange }
									data={ form_data }
								/>

								<button type="button" className="form__pwd-toggle-btn"
									style={ { marginBottom: 12 } }
									onClick={ component.togglePwdVisibility }
									title={ state.pwd_type === 'password' ? 'Montrer le mot de passe' : 'Masquer le mot de passe' }>
									<PwdIcon className="form__pwd-toggle-icon" />
								</button>
							</div>
						</div>

						<div className="o-grid__item">
							<div className="form__pwd-toggle-field">
								<FormElement type={ state.pwd_conf_type }
									name="password_confirmation"
									label="Confirmation de mot de passe"
									id_prefix="new-password-form-"
									onChange={ component.handleChange }
									data={ form_data }
								/>

								<button type="button" className="form__pwd-toggle-btn"
									style={ { marginBottom: 12 } }
									onClick={ component.togglePwdConfVisibility }
									title={ state.pwd_conf_type === 'password' ? 'Montrer le mot de passe' : 'Masquer le mot de passe' }>
									<PwdConfIcon className="form__pwd-toggle-icon" />
								</button>
							</div>
						</div>

					</div>

					<FormElement type="hidden" name="token[string]"
						onChange={ component.handleChange } data={ form_data } />

					{ status_message }

				</div>

				<FormElement type="hidden" name="token" id_prefix="registration-form-"
					data={ form_data } />

				<div className="o-content">

					{ submit }

				</div>

			</Form>

		);

		return output;
	}
}